require('./price-promise-multi-select.scss');
require('src/interlock/ui/expandable/expandable');
require('src/interlock/ui/color/color');

//var ppCertificate = require('src/interlock/lead/certificate/inventory/new/price-promise');
var eventToolbox = require('src/interlock/no-ui/utils/event-toolbox/event-toolbox');


var queryString = require('query-string');
//var deferredLoader = require('src/interlock/no-ui/defer/loader');


var $leadFormPPThankYouDrawer = $('.lead-form-price-promise-thank-you.modal-drawer');
//var $leadFormPPCertificateDrawer = $('.lead-form-price-promise-certificate.modal-drawer');


function closePrint () {
    document.body.removeChild(this.__container__);
}

function setPrint () {
    this.contentWindow.__container__ = this;
    this.contentWindow.onbeforeunload = closePrint;
    this.contentWindow.onafterprint = closePrint;
    this.contentWindow.focus(); // Required for IE
    this.contentWindow.print();
}

function printPage (sURL) {
    var oHiddFrame = document.createElement('iframe');
    oHiddFrame.onload = setPrint;
    oHiddFrame.style.visibility = 'hidden';
    oHiddFrame.style.position = 'fixed';
    oHiddFrame.style.right = '0';
    oHiddFrame.style.bottom = '0';
    oHiddFrame.src = sURL;
    document.body.appendChild(oHiddFrame);
}

$leadFormPPThankYouDrawer.on('click', '.print-price-promise', function() {
    var url = '/groundwork/lead/certificate/inventory/new/price-promise/?';
    var $el = $(this);
    var vin = $el.data('vin');
    url = url + '&vin='+vin;
    printPage(url);
});

function makeParamsStr(params) {
    return queryString.stringify(params, {
        strict: true,
        encode: true
    });
}

function fireThankyouTracking(){
    var matchObj = window.EDMDataStorage.thankyouMatches;
    var savingRetrieval = JSON.parse($('input[name="thankyouTrack"]')[0].value);
    if(savingRetrieval) {
        var matchingDealers = savingRetrieval.event_data.loc_id_list.split(',');
        var matchingMatches = '';
        matchingDealers.forEach(function(el){
            matchingMatches += matchObj[el]+',';
        });
        savingRetrieval.event_data.match_type_list = matchingMatches.substring(0, (matchingMatches.length - 1));
        savingRetrieval.event_data.action_category = 'system';
        savingRetrieval.ads = {
            disable_refresh: true
        };
        eventToolbox.fireAction(savingRetrieval); //pixel gets fired here
    }
    eventToolbox.fireAction({
        'event_type': 'action_end',
        'ads': {
            'disable_refresh': true
        },
        'event_data': {
            'action_category': 'user',
            'action_name': 'lead_submission',
            'subaction_name': 'submit',
            'action_cause': 'button_click',
            'creative_id': 'edm-entry-pricing-lead-form-thank-you'
        }
    });
}


module.exports = {
    loadThankyouPage: function (params) {
        fireThankyouTracking();
        makeParamsStr(params);
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/lead/thank-you/inventory/pricing/price-promise-multi-select.js
// module id = 152
// module chunks = 0 1 16 19